import { documentosPersonalesOptions } from "@/lib/affiliateOptions";
import { SectionCard, StepShell } from "./ui";
import DocumentSlots from "./DocumentSlots";
import type { AfiliacionForm, DocumentoForm } from "./types";

interface StepDocumentosProps {
  form: AfiliacionForm;
  setDocumentosGenerales: (docs: DocumentoForm[]) => void;
}

const empresaDocs = ["RNC", "Registro mercantil", "Referencias comerciales", "Otros documentos"];

export default function StepDocumentos({ form, setDocumentosGenerales }: StepDocumentosProps) {
  const isEmpresa = form.tipo === "empresa";
  const tipos = isEmpresa ? empresaDocs : documentosPersonalesOptions;

  return (
    <StepShell
      title="Documentación"
      description="Puedes subir documentos ahora o más adelante. Por el momento son opcionales; AXONIA GROUP podría solicitarlos durante la revisión."
    >
      <div className="space-y-5">
        <SectionCard title={isEmpresa ? "Documentos de la empresa" : "Documentos personales"} icon="ri-folder-shield-line">
          <DocumentSlots
            tipos={tipos}
            docs={form.documentosGenerales}
            onChange={setDocumentosGenerales}
            folder="personales"
            hint="Formatos permitidos: PDF, JPG, PNG o WebP (máx. 8 MB). Almacenamiento privado."
          />
        </SectionCard>

        <div className="flex items-start gap-3 rounded-lg border border-accent-300 bg-accent-50 p-4">
          <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className="ri-lock-line text-base leading-none" aria-hidden="true"></i>
          </span>
          <div>
            <h3 className="text-sm font-heading font-semibold text-accent-900">Privacidad garantizada</h3>
            <p className="mt-1 text-xs leading-relaxed text-accent-900">
              Toda la documentación (matrículas, seguros, licencias, cédula, RNC) se almacena de forma
              privada. Nunca aparece en el sitio público ni en buscadores.
            </p>
          </div>
        </div>
      </div>
    </StepShell>
  );
}